import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import store from './store'
import './plugins/axios'
import './plugins/gtm'
import './plugins/alasql'
import './plugins/toastr'
import '@/assets/styl/style.styl'
import './directives/addHtml'
import { checkErros } from '@/api-erros.js'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import * as icons from  './components/ui-icons'

Object.entries(icons).forEach(([name, icon]) => {
  Vue.component(name, icon);
});

Vue.use(PerfectScrollbar)

checkErros()

const moment = require('moment')
require('moment/locale/pt-br')
 
Vue.use(require('vue-moment'), {
  moment
})

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
